<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center v-if="companyAccount && !loading">
        <v-icon small>account_balance</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: true,
              text: companyAccount
                ? companyAccount.company && companyAccount.company.isSupplier
                  ? 'Supplier Accounts'
                  : 'Customers Accounts'
                : 'Companies Accounts',
              disabled: false,
              to: companyAccount
                ? companyAccount.company && companyAccount.company.isSupplier
                  ? '/company_accounts/suppliers_accounts'
                  : '/company_accounts/customers_accounts'
                : '/company_accounts',
            },
            {
              exact: true,
              text: companyAccount && companyAccount.company_name,
              disabled: !(
                companyAccount &&
                companyAccount.company &&
                companyAccount.company.id
              ),
              to:
                '/companies/' +
                (companyAccount &&
                  companyAccount.company &&
                  companyAccount.company.id),
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
        <v-icon>chevron_right</v-icon>
        <span class="breadcrumb_current_page white--text">{{
          companyAccount && companyAccount.currency.code
        }}</span>
        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>
    </v-toolbar>
    <v-container fluid fill-height class="pt-2">
      <v-layout row align-center justify-center>
        <v-card max-width="1280" width="100%" flat v-if="!loading">
          <companyAccountShow
            :companyBalance="companyAccount"
            :accountAmount="0"
          />
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import companyAccountShow from "../components/accounting/company_accounts/companyAccountShow";
import headerProfile from "../components/shared/headerProfile";
import SHOW_COMPANY_BALANCE from "../graphql/company_balances/show.gql";

export default {
  name: "companyBalancesIndex",
  components: {
    companyAccountShow,
    headerProfile,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("commonStore", ["companyAccount"]),
  },
  methods: {
    fetchCompanyBalance(company_balance_id) {
      this.loading = true;
      console.log("fetching id:", company_balance_id);

      this.fetchAndSubscribe(
        SHOW_COMPANY_BALANCE,
        { id: company_balance_id },
        "commonStore",
        "companyAccount"
      )
        .then((data) => {
          this.loading = false;
        })
        .catch((e) => {
          console.log("ERROR");
          this.loading = false;
        });
    },
  },
  created() {
    if (this.$route.params.id) this.fetchCompanyBalance(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped>
td {
  cursor: pointer;
}
</style>
